import { axios } from '@/utils/request'

/**
 * 删除购货订单
 * @param parameter
 * @returns {*}
 */
export function deletePurchaseBill (parameter) {
  return axios({
    url: '/purchase/billdelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除销货订单
 * @param parameter
 * @returns {*}
 */
export function deleteSalesBill (parameter) {
  return axios({
    url: '/sales/billdelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 创建购货订单
 * @param parameter
 * @returns {*}
 */
export function addPurchaseBill (parameter) {
  return axios({
    url: '/purchase/billadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 读取购货订单详情
 * @param parameter
 * @returns {*}
 */
export function getPurchaseBillDetail (parameter) {
  return axios({
    url: '/purchase/billdetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 新建购货单
 * @param parameter
 * @returns {*}
 */
export function addPurchaseInvoice (parameter) {
  return axios({
    url: '/purchase/invoiceadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 新建购货退货单
 * @param parameter
 * @returns {*}
 */
export function addPurchaseRecede (parameter) {
  return axios({
    url: '/purchase/recedeadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 修改购货订单
 * @param parameter
 * @returns {*}
 */
export function editPurchaseBill (parameter) {
  return axios({
    url: '/purchase/billedit',
    method: 'post',
    params: { id: parameter.id },
    data: parameter
  })
}

/**
 * 读取购货订单记录
 * @param parameter
 * @returns {*}
 */
export function getPurchaseBillList (parameter) {
  return axios({
    url: '/purchase/billlist',
    method: 'get',
    params: parameter
  })
}

/**
 * 读取购货单记录
 * @param parameter
 * @returns {*}
 */
export function getPurchaseInvoiceList (parameter) {
  return axios({
    url: '/purchase/invoicelist',
    method: 'get',
    params: parameter
  })
}

/**
 * 购货单详情
 * @param parameter
 * @returns {*}
 */
export function getPurchaseInvoiceDetail (parameter) {
  return axios({
    url: '/purchase/invoicedetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 购货退货单详情
 * @param parameter
 * @returns {*}
 */
export function getPurchaseRecedeDetail (parameter) {
  return axios({
    url: '/purchase/recededetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 购货退货单记录
 * @param parameter
 * @returns {*}
 */
export function getPurchaseRecedeList (parameter) {
  return axios({
    url: '/purchase/recedelist',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除购货退货单
 * @param parameter
 * @returns {*}
 */
export function deletePurchaseRecede (parameter) {
  return axios({
    url: '/purchase/recededelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除购货单
 * @param parameter
 * @returns {*}
 */
export function deletePurchaseInvoice (parameter) {
  return axios({
    url: '/purchase/invoicedelete',
    method: 'post',
    data: parameter
  })
}

/*  -------------------sales----------------------  */

/**
 * 新建销售订单
 * @param parameter
 * @returns {*}
 */
export function addSalesBill (parameter) {
  return axios({
    url: '/sales/billadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 销售订单记录
 * @param parameter
 * @returns {*}
 */
export function getSalesBillList (parameter) {
  return axios({
    url: '/sales/billlist',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改销售订单
 * @param parameter
 * @returns {*}
 */
export function editSalesBill (parameter) {
  return axios({
    url: '/sales/billedit',
    method: 'post',
    params: { id: parameter.id },
    data: parameter
  })
}

/**
 * 销售订单详情
 * @param parameter
 * @returns {*}
 */
export function getSalesBillDetail (parameter) {
  return axios({
    url: '/sales/billdetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 新建销货单
 * @param parameter
 * @returns {*}
 */
export function addSalesInvoice (parameter) {
  return axios({
    url: '/sales/invoiceadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 销货单记录
 * @param parameter
 * @returns {*}
 */
export function getSalesInvoiceList (parameter) {
  return axios({
    url: '/sales/invoicelist',
    method: 'get',
    params: parameter
  })
}

/**
 * 销货单详情
 * @param parameter
 * @returns {*}
 */
export function getSalesInvoiceDetail (parameter) {
  return axios({
    url: '/sales/invoicedetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除销货单
 * @param parameter
 * @returns {*}
 */
export function deleteSalesInvoice (parameter) {
  return axios({
    url: '/sales/invoicedelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 新建销货退货单
 * @param parameter
 * @returns {*}
 */
export function addSalesRecede (parameter) {
  return axios({
    url: '/sales/recedeadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 销货退货单记录
 * @param parameter
 * @returns {*}
 */
export function getSalesRecedeList (parameter) {
  return axios({
    url: '/sales/recedelist',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除销货退货单
 * @param parameter
 * @returns {*}
 */
export function deleteSalesRecede (parameter) {
  return axios({
    url: '/sales/recededelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 销货退货单详情
 * @param parameter
 * @returns {*}
 */
export function getSalesRecedeDetail (parameter) {
  return axios({
    url: '/sales/recededetail',
    method: 'get',
    params: parameter
  })
}

/* --------------------- report ----------------*/

/**
 * 采购明细表
 * @param parameter
 * @returns {*}
 */
export function purchaseReportEntries (parameter) {
  return axios({
    url: '/purchase/reportentries',
    method: 'get',
    params: parameter
  })
}

/**
 * 销货明细表
 * @param parameter
 * @returns {*}
 */
export function salesReportEntries (parameter) {
  return axios({
    url: '/sales/reportentries',
    method: 'get',
    params: parameter
  })
}

/**
 * 采购汇总表（按商品）
 * @param parameter
 * @returns {*}
 */
export function purchaseReportSummary (parameter) {
  return axios({
    url: '/purchase/reportsummary',
    method: 'get',
    params: parameter
  })
}

/**
 * 销货汇总表（按商品）
 * @param parameter
 * @returns {*}
 */
export function salesReportSummary (parameter) {
  return axios({
    url: '/sales/reportsummary',
    method: 'get',
    params: parameter
  })
}

/* --------------------storage--------------------*/

/**
 * 新增入库单
 * @param parameter
 * @returns {*}
 */
export function addStorageIn (parameter) {
  return axios({
    url: '/storage/inadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 入库单记录
 * @param parameter
 * @returns {*}
 */
export function getStorageInList (parameter) {
  return axios({
    url: '/storage/inlist',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除入库单
 * @param parameter
 * @returns {*}
 */
export function deleteStorageIn (parameter) {
  return axios({
    url: '/storage/indelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取入库单详情
 * @param parameter
 * @returns {*}
 */
export function getStorageInDetail (parameter) {
  return axios({
    url: '/storage/indetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 新建出库单
 * @param parameter
 * @returns {*}
 */
export function addStorageOut (parameter) {
  return axios({
    url: '/storage/outadd',
    method: 'post',
    data: parameter
  })
}

/**
 * 出库单记录
 * @param parameter
 * @returns {*}
 */
export function getStorageOutList (parameter) {
  return axios({
    url: '/storage/outlist',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除出库单
 * @param parameter
 * @returns {*}
 */
export function deleteStorageOut (parameter) {
  return axios({
    url: '/storage/outdelete',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取出库单详情
 * @param parameter
 * @returns {*}
 */
export function getStorageOutDetail (parameter) {
  return axios({
    url: '/storage/outdetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 商品收发明细表
 * @param parameter
 * @returns {*}
 */
export function storageReportDetail (parameter) {
  return axios({
    url: '/storage/reportdetail',
    method: 'get',
    params: parameter
  })
}
